import axios from 'axios';

/**
 * Lógica de Higienização de URL:
 * Garante que a baseURL aponte para o domínio correto e HTTPS em produção.
 */
const getBaseURL = () => {
    const defaultURL = 'https://range360.com.br/api';
    let url = process.env.NEXT_PUBLIC_API_URL || defaultURL;
    
    url = url.replace(/\/+$/, "");

    if (url.endsWith('/api/v1')) {
        return url;
    } else if (url.endsWith('/api')) {
        return `${url}/v1`;
    } else {
        return `${url}/api/v1`;
    }
};

const api = axios.create({
    baseURL: getBaseURL(),
    headers: { 
        'Content-Type': 'application/json' 
    },
});

api.interceptors.request.use((config) => {
    if (typeof window !== 'undefined') {
        const token = localStorage.getItem('@LucianoSystem:token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }
    return config;
});

export default api;